export const RecaptchaActions = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  ENROLLMENT_ADD: 'enrollment_add',
  PASSWORD_RESET_REQUEST: 'password_reset_request',
};
